/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';
import { WorkElektroDrittkontrolleProjectDto } from '../models/work-elektro-drittkontrolle-project-dto';
import { WorkElektroDrittkontrolleSortByEnum } from '../models/work-elektro-drittkontrolle-sort-by-enum';
import { WorkElektroDrittkontrolleStatusEnum } from '../models/work-elektro-drittkontrolle-status-enum';
import { WorkTask } from '../models/work-task';
import { WorkUpdateTaskDto } from '../models/work-update-task-dto';

@Injectable({ providedIn: 'root' })
export class WorkElektroDrittkontrolleV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerGetProjects()` */
  static readonly ElektroDrittkontrolleV2ControllerGetProjectsPath = '/v2/projects/elektro-drittkontrolle/projects';

  /**
   * Required permissions: elektrodrittkontrolle:read, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerGetProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerGetProjects$Response(
    params: {
      status: WorkElektroDrittkontrolleStatusEnum;
      page: number;
      take: number;
      sortBy: Array<WorkElektroDrittkontrolleSortByEnum>;
      businessunitIds?: Array<string>;
      teamIds?: Array<string>;

    /**
     * Filtert (nur Status BILLED) nach Rechnungsmonat des Kreditors im Format YYYY-MM.
     */
      filterMonth?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkElektroDrittkontrolleProjectDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerGetProjectsPath, 'get');
    if (params) {
      rb.query('status', params.status, {});
      rb.query('page', params.page, {});
      rb.query('take', params.take, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('teamIds', params.teamIds, {});
      rb.query('filterMonth', params.filterMonth, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkElektroDrittkontrolleProjectDto>>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:read, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerGetProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerGetProjects(
    params: {
      status: WorkElektroDrittkontrolleStatusEnum;
      page: number;
      take: number;
      sortBy: Array<WorkElektroDrittkontrolleSortByEnum>;
      businessunitIds?: Array<string>;
      teamIds?: Array<string>;

    /**
     * Filtert (nur Status BILLED) nach Rechnungsmonat des Kreditors im Format YYYY-MM.
     */
      filterMonth?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkElektroDrittkontrolleProjectDto>> {
    return this.elektroDrittkontrolleV2ControllerGetProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkElektroDrittkontrolleProjectDto>>): Array<WorkElektroDrittkontrolleProjectDto> => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerUpdateTask()` */
  static readonly ElektroDrittkontrolleV2ControllerUpdateTaskPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}';

  /**
   * Required permissions: tasks:update, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerUpdateTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elektroDrittkontrolleV2ControllerUpdateTask$Response(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerUpdateTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: tasks:update, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerUpdateTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elektroDrittkontrolleV2ControllerUpdateTask(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerUpdateTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerAcceptTask()` */
  static readonly ElektroDrittkontrolleV2ControllerAcceptTaskPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}/accept';

  /**
   * Required permissions: elektrodrittkontrolle:accept, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerAcceptTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerAcceptTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerAcceptTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:accept, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerAcceptTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerAcceptTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerAcceptTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerDeclineTask()` */
  static readonly ElektroDrittkontrolleV2ControllerDeclineTaskPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}/decline';

  /**
   * Required permissions: elektrodrittkontrolle:decline, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerDeclineTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerDeclineTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerDeclineTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:decline, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerDeclineTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerDeclineTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerDeclineTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerCompleteTask()` */
  static readonly ElektroDrittkontrolleV2ControllerCompleteTaskPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}/complete';

  /**
   * Required permissions: elektrodrittkontrolle:complete, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerCompleteTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerCompleteTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerCompleteTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:complete, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerCompleteTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerCompleteTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerCompleteTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerSetConfirmationSent()` */
  static readonly ElektroDrittkontrolleV2ControllerSetConfirmationSentPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}/confirmationSent';

  /**
   * Required permissions: elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerSetConfirmationSent()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerSetConfirmationSent$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerSetConfirmationSentPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerSetConfirmationSent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerSetConfirmationSent(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerSetConfirmationSent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerAssignTaskToTeam()` */
  static readonly ElektroDrittkontrolleV2ControllerAssignTaskToTeamPath = '/v2/projects/elektro-drittkontrolle/tasks/{id}/team/{teamId}';

  /**
   * Required permissions: elektrodrittkontrolle:assign, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerAssignTaskToTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerAssignTaskToTeam$Response(
    params: {
      id: number;
      teamId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerAssignTaskToTeamPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('teamId', params.teamId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:assign, elektrodrittkontrolle:update, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerAssignTaskToTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerAssignTaskToTeam(
    params: {
      id: number;
      teamId: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.elektroDrittkontrolleV2ControllerAssignTaskToTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects()` */
  static readonly ElektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjectsPath = '/v2/projects/elektro-drittkontrolle/createBillingsForFinishedProjects';

  /**
   * Required permissions: elektrodrittkontrolle:bill
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjectsPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:bill
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.elektroDrittkontrolleV2ControllerCreateBillingsForFinishedProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `elektroDrittkontrolleV2ControllerGenerateInvoiceDocument()` */
  static readonly ElektroDrittkontrolleV2ControllerGenerateInvoiceDocumentPath = '/v2/projects/elektro-drittkontrolle/generateInvoiceDocument/{creditorNumber}';

  /**
   * Required permissions: elektrodrittkontrolle:read, elektrodrittkontrolle:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elektroDrittkontrolleV2ControllerGenerateInvoiceDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerGenerateInvoiceDocument$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      creditorNumber: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(this.rootUrl, WorkElektroDrittkontrolleV2Service.ElektroDrittkontrolleV2ControllerGenerateInvoiceDocumentPath, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.path('creditorNumber', params.creditorNumber, {});
    }

    return this.http.request(
      rb.build({ responseType: 'blob', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Required permissions: elektrodrittkontrolle:read, elektrodrittkontrolle:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `elektroDrittkontrolleV2ControllerGenerateInvoiceDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elektroDrittkontrolleV2ControllerGenerateInvoiceDocument(
    params: {
      format: WorkDocxOutputFormatEnum;
      creditorNumber: string;
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.elektroDrittkontrolleV2ControllerGenerateInvoiceDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
